module.exports = __webpack_public_path__ + "static/media/zocalo15.f56c8b46.jpg";